document.addEventListener('DOMContentLoaded', weglotSetup, false)

let currentLang = 'en'
if (!window.localStorage.getItem('lang')) {
  window.localStorage.setItem('lang', currentLang)
  document.tidioChatLang = currentLang
  document.querySelector('html').setAttribute('lang', currentLang)
} else {
  const localSotrageLang = window.localStorage.getItem('lang')
  document.tidioChatLang = localSotrageLang
  document.querySelector('html').setAttribute('lang', localSotrageLang)
}

function weglotSetup() {
  const weglot = window.Weglot

  if (weglot) {
    document.querySelector('.weglot-container') ? weglotInit() : setTimeout(weglotInit, 1000)
  }
}

function weglotInit() {
  const weglot = window.Weglot
  document.querySelector('.weglot-container')
    ? document.querySelector('.weglot-container').style.display = 'none'
    : ''

    const langSelector = document.querySelector('.lang-selector')
  currentLang = weglot.getCurrentLang()
  langSelector.innerHTML = currentLang === 'fr' ? 'en' : 'fr'
  window.localStorage.setItem('lang', currentLang);
  document.querySelector('html').setAttribute('lang', currentLang)

  langSelector.addEventListener('click', () => {
    pastLang = currentLang
    currentLang = currentLang === 'fr' ? 'en' : 'fr'
    weglot.switchTo(currentLang)
    window.localStorage.setItem('lang', currentLang)
    document.querySelector('html').setAttribute('lang', currentLang)
    langSelector.innerHTML = pastLang
  })
}

// Tidio
(function() {
  let tidioChatbot

  function onTidioChatApiReady() {
    // Language
    const weglot = window.Weglot

    if (weglot) {
      document.querySelector('.weglot-container') ? tidioLang() : setTimeout(tidioLang, 1000)
    }
  }

  function tidioLang() {
    window.Weglot.on('languageChanged', () => {
      document.tidioChatLang = window.Weglot.getCurrentLang()
    })
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady)
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady)
  }
})();

// Open the tier 3 nav container on mobile after loading
setTimeout(() => {
  const navTierTwo = document.querySelector('.mobile-navigation-drawer')?.querySelector('.navigation__tier-2-container')
  const navItemParent = navTierTwo?.querySelector('.navigation__item--with-children')
  const navTierThree = navItemParent?.querySelector('.navigation__tier-3-container.navigation__child-tier')
  const allLinks = navTierThree.querySelector('.navigation__tier-3')?.querySelectorAll('.navigation__item')
  let totalHeight = 20
  allLinks.forEach(link => {
    totalHeight += link.clientHeight
  })
  if (navItemParent) navItemParent.classList.add('navigation__item--open')
  if (navTierThree) navTierThree.style = `height: ${totalHeight}px`
}, 500)
